<template>
  <div id="app">
    <!----------------------------------------页面显示区域-------------------------------------->
    <div :class="$route.meta.isTab ? 'main_body' : 'single_body'">
      <!-- 需要缓存的视图组件 -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <!-- 不需要缓存的视图组件 -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>

    <wl-tab></wl-tab>
  </div>
</template>
<script>
import { mapState } from "vuex";
import wlTab from "@/components/wl-tab";
import wxShare from "./utils/wechat";
export default {
  name: "App",
  components: { wlTab },
  mixins: [wxShare],
  computed: {},
  data: function () {
    return {
      load_lock: true,
    };
  },
  watch: {
    $route(to, from) {
      this.setShare();
      this.checkLogin();
    },
  },
  computed: {
    ...mapState(['userInfo','authToken'])
  },
  created: function () {},
  mounted() {
    if(!this.$glf.isMobile()){
      console.log('跳转电脑端')
      window.location.href = "http://pc.xinyuhealth.com/";
      return false;
    }

    //获取系统数据字典
    this.$api.getByTypes({ types: ["USER_TYPE", "CMS_ARTICLE_TYPE", "USER_TITLE"]}).then(res=>{
      var data = res.data;
      var user_type = {};
      var article_type = {};
      var user_title = {};
      data.USER_TYPE.map(r=>{
        user_type[r.value] = r.text;
      })
      data.CMS_ARTICLE_TYPE.map(r=>{
        article_type[r.value] = r.text;
      })
      data.USER_TITLE.map(r=>{
        user_title[r.value] = r.text;
      })
      this.$store.commit('setSysData',{user_type,article_type,user_title});
    });
    this.checkLogin();
    this.setShare();
  },
  methods: {
    //验证登陆
    checkLogin() {
      if (
        !this.$store.state.login &&
        ["load", "login", "auth"].indexOf(this.$route.name) === -1
      ) {
      }
    },
    //注册分享
    setShare() {
      if(this.$route.name!=='article_info'){
        let url = window.location.origin;
        const shareInfo = {
          title: "歆医荟",
          desc: "歆医荟",
          link: `${url}/master`,
          img: `${url}/static/image/share.png?v=111`,
        };
        this.wechatShare(shareInfo);
      }

    },
  },
};
</script>

<style lang="scss">
body {
  background-color: #fff;
}
#app {
  max-width: 375px;
  display: block;
  margin: 0 auto;
  position: relative;
}
.main_body {
  width: 100%;
  height: calc(100% - 60px);
  overflow-y: auto;
  background-color: #fff;
}
.single_body {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue